/**
 * True if URL points to a WebM (upload URL, library proxy with key=..., etc.).
 */
export function isWebmUrl(url) {
  if (!url || typeof url !== "string") return false;
  const s = url.toLowerCase();
  const path = s.split("?")[0].split("#")[0];
  if (path.endsWith(".webm")) return true;
  const keyMatch = s.match(/[?&]key=([^&]+)/);
  if (keyMatch && decodeURIComponent(keyMatch[1]).toLowerCase().endsWith(".webm")) {
    return true;
  }
  return false;
}
